module.exports = __webpack_public_path__ + "img/addAcount.424f25f4.jpg";